import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { useTranslation } from "react-i18next";
import componentStyles from "../assets/styles/components/config_list";
import DialogContentText from "@material-ui/core/DialogContentText";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { deleteAccount } from "../actions";
import { Auth } from "aws-amplify";

const useStyles = makeStyles(componentStyles);

const Alert = (props) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const DeleteUserAccount = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [notification, setNotification] = useState(false);
  const [agree, setAgree] = useState(false);
  const [sending, setSending] = useState(false);
  const [errorMessage, setErrorMessage] = useState({ message: null });

  const { t } = useTranslation();
  const handleClickOpenWindow = () => setOpen(true);
  const handleClickClose = () => {
    setOpen(false);
    setAgree(false);
  };
  const handleAgreeChange = (e) => setAgree(e.target.checked);
  const handleNotificationClose = () => setNotification(false);
  const handleClickDeleteUserAccountButton = async () => {
    setSending(true);
    let res = null;
    try {
      const user = await Auth.currentAuthenticatedUser();
      const values = {
        id: user.attributes.sub,
        email: user.attributes.email,
        username: user.username,
      };
      res = await deleteAccount(values);
    } catch (err) {
      setErrorMessage({ message: err });
    }

    if (res) {
      if (res.errors) {
        setErrorMessage({
          message: t("home.delete_user_account.error_message"),
        });
      } else {
        setErrorMessage({ message: null });
        setOpen(false);
        setAgree(false);
        setNotification(true);
      }
    } else {
      setErrorMessage({ message: t("home.delete_user_account.error_message") });
    }
    setSending(false);
  };
  return (
    <>
      <Grid container justify="center">
        <Grid item xs={12} component={Box} marginBottom="3rem!important">
          <Typography variant="body1" style={{ margin: 20 }}>
            下記ボタンからRedMica Bridgeのアカウント削除を依頼できます。
            <br />
            注意事項を確認の上、ご依頼ください。
          </Typography>

          <Typography variant="body1" style={{ marginLeft: 20 }}>
            注意事項
          </Typography>
          <div style={{ marginLeft: 20 }}>
            <List>
              <ListItem className={classes.DeleteNotesListWrap}>
                <ListItemIcon className={classes.DeleteNotesListIcon}>
                  <KeyboardArrowRightIcon />
                </ListItemIcon>
                <ListItemText primary="削除依頼を受付した翌月初旬の弊社指定日に、RedMica Bridgeのアカウント削除を実施します。" />
              </ListItem>
              <ListItem className={classes.DeleteNotesListWrap}>
                <ListItemIcon className={classes.DeleteNotesListIcon}>
                  <KeyboardArrowRightIcon />
                </ListItemIcon>
                <ListItemText primary="アカウント削除時、RedMica Bridgeに登録されたデータ（RedmineのAPIキー、RedmineのURL、Redmineの表示名）はすべて削除します。" />
              </ListItem>
              <ListItem className={classes.DeleteNotesListWrap}>
                <ListItemIcon className={classes.DeleteNotesListIcon}>
                  <KeyboardArrowRightIcon />
                </ListItemIcon>
                <ListItemText primary="削除したRedMica Bridgeのデータは復元できません。" />
              </ListItem>
            </List>
          </div>

          <Grid item xs={12} component={Box} marginBottom="1rem!important">
            <FormControlLabel
              control={
                <Checkbox
                  checked={agree}
                  onChange={handleAgreeChange}
                  name="agreeChecked"
                  color="primary"
                />
              }
              label={t("home.delete_user_account.agree")}
            />
          </Grid>
          <Grid item xs={12} component={Box}>
            <Button
              variant="contained"
              classes={{ root: classes.buttonDelete }}
              size="small"
              onClick={(e) => handleClickOpenWindow()}
              disabled={!agree}
            >
              {t("home.delete_user_account.button_delete")}
            </Button>
          </Grid>
        </Grid>
      </Grid>

      <Dialog
        fullWidth
        maxWidth={"md"}
        open={open}
        onClose={handleClickClose}
        aria-labelledby="max-width-dialog-title"
      >
        <DialogTitle id="alert-dialog-title">
          <Typography variant="h3">
            {t("home.delete_user_account.confirm")}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            RedMica Bridgeのアカウントの削除を依頼しますか？
            <br />
            この操作は取り消せません。
          </DialogContentText>
        </DialogContent>
        {errorMessage.message ? (
          <DialogContent>
            <DialogContentText id="alert-dialog-error">
              {errorMessage.message}
            </DialogContentText>
          </DialogContent>
        ) : null}
        <DialogActions>
          <Button onClick={handleClickClose} color="primary" autoFocus>
            {t("button_cancel")}
          </Button>
          <Button
            onClick={(e) => handleClickDeleteUserAccountButton()}
            classes={{ root: classes.buttonDelete }}
            disabled={sending}
          >
            {t("home.delete_user_account.button_delete")}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar open={notification}>
        <Alert onClose={handleNotificationClose} severity="success">
          削除依頼を受け付けました。月末または月初に削除処理をおこないますので、しばらくお待ちください。
        </Alert>
      </Snackbar>
    </>
  );
};
export default DeleteUserAccount;
